jQuery(document).ready(function () {
    let compare_at_price;
    let price;
    let product_percentage;
    if (jQuery(".item-sub").length > 0) {
        setTimeout(() => {
            jQuery(".list-sub-collection").slick({
                dots: false,
                arrows: true,
                pauseOnFocus: true,
                pauseOnHover: true,
                slidesToShow: 8,
                slidesToScroll: 1,
                prevArrow:
                    "<div class='slick-prev slick-arrow'><i class='slick-icon-c fa fa-chevron-left'></i></div>",
                nextArrow:
                    "<div class='slick-next slick-arrow'><i class='slick-icon-c fa fa-chevron-right'></i></div>",
                responsive: [
                    {
                        breakpoint: 1440,
                        settings: {
                            slidesToShow: 6,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });
        }, 500);
    }

    // var valueOptionQuickView = [];
    // let indexOptionQuickView = 1;
    // jQuery(".qview-select select option").each(function () {
    //     jQuery(this).attr("id", `quick-view-${indexOptionQuickView}`);
    //     valueOptionQuickView.push(jQuery(this).text());
    //     indexOptionQuickView++;
    // });

    if(jQuery('.template-product').length > 0){
        jQuery(function () {
            var icons = {
                header: "iconClosed", // custom icon class
                activeHeader: "iconOpen", // custom icon class
            };
            jQuery("#accordion-promosi, #accordion-pengiriman").accordion({
                active: false,
                collapsible: true,
                icons: icons,
            });
        });
    }

    if(jQuery('#accordion-faq').length > 0){
        jQuery(function () {
            var icons = {
                header: "iconClosed", // custom icon class
                activeHeader: "iconOpen", // custom icon class
            };
            jQuery("#accordion-faq").accordion({
                active: false,
                collapsible: true,
                icons: icons,
            });
        });
    }

    if(jQuery('#accordion-faq2').length > 0){
        jQuery(function () {
            var icons = {
                header: "iconClosed", // custom icon class
                activeHeader: "iconOpen", // custom icon class
            };
            jQuery("#accordion-faq2").accordion({
                active: false,
                collapsible: true,
                icons: icons,
            });
        });
    }

    if(jQuery('#accordion-custom').length > 0){
        jQuery(function () {
            var icons = {
                header: "iconClosed", // custom icon class
                activeHeader: "iconOpen", // custom icon class
            };
            jQuery("#accordion-custom").accordion({
                active: false,
                collapsible: true,
                icons: icons,
            });
        });
    }

    // Size Ggide
    if(jQuery('.template-page').length > 0){
        jQuery("#sg-shoe-adult").click(function () {
            jQuery(".sg-shoe-adult").css({ opacity: "1 ", "font-weight": "bold" });
            jQuery(".sg-kids").css({ opacity: "0.7 ", "font-weight": "500" });
            jQuery(".sg-bags").css({ opacity: "0.7 ", "font-weight": "500" });
    
            jQuery(".content-shoes-adult").css({ display: "block " });
            jQuery(".content-kids").css({ display: "none " });
            jQuery(".content-bags").css({ display: "none " });
        });
        jQuery("#sg-kids").click(function () {
            jQuery(".sg-shoe-adult").css({ opacity: "0.7 ", "font-weight": "500" });
            jQuery(".sg-kids").css({ opacity: "1 ", "font-weight": "bold" });
            jQuery(".sg-bags").css({ opacity: "0.7 ", "font-weight": "500" });
    
            jQuery(".content-shoes-adult").css({ display: "none " });
            jQuery(".content-kids").css({ display: "block " });
            jQuery(".content-bags").css({ display: "none " });
        });
        jQuery("#sg-bags").click(function () {
            jQuery(".sg-shoe-adult").css({ opacity: "0.7 ", "font-weight": "500" });
            jQuery(".sg-kids").css({ opacity: "0.7 ", "font-weight": "500" });
            jQuery(".sg-bags").css({ opacity: "1 ", "font-weight": "bold" });
    
            jQuery(".content-shoes-adult").css({ display: "none " });
            jQuery(".content-kids").css({ display: "none " });
            jQuery(".content-bags").css({ display: "block " });
        });
    }

    // get value menu dropdown
    $("#size-guide").change(function () {
        // var getSizeGUideSelected = jQuery("#size-guide")
        //     .find(":selected")
        //     .text();

        if (jQuery(this).val() == "shoes-adult") {
            jQuery(".content-shoes-adult").css({ display: "block " });
            jQuery(".content-kids").css({ display: "none " });
            jQuery(".content-bags").css({ display: "none " });
        } else if (jQuery(this).val() == "kids") {
            jQuery(".content-shoes-adult").css({ display: "none " });
            jQuery(".content-kids").css({ display: "block " });
            jQuery(".content-bags").css({ display: "none " });
        } else {
            jQuery(".content-shoes-adult").css({ display: "none " });
            jQuery(".content-kids").css({ display: "none " });
            jQuery(".content-bags").css({ display: "block " });
        }
    });

    // Tab Staytion
    jQuery(".ProductMeta__Description .station-tabs-tabset").removeClass(
        "mod-vertical"
    );

    // Login Social
    jQuery(
        ".layout-zify-social-8.zify-size-normal-2 .zify-social-connect:before"
    ).css("left", "100px");
    jQuery(".zifyapps-sociallogin-wrapper img").css("display", "none");
    jQuery(".zifyapps-sociallogin-wrapper a[title=Facebook] span").text(
        "Sign in with Facebook"
    );
    jQuery(".zifyapps-sociallogin-wrapper a[title=Google] span").text(
        "Sign in with Google"
    );

    if (jQuery(".sub-item").length > 0) {
        jQuery(".list-icon").slick({
            dots: false,
            arrows: true,
            pauseOnFocus: true,
            pauseOnHover: true,
            slidesToShow: 7,
            slidesToScroll: 1,
            prevArrow:
                "<div class='slick-prev slick-arrow'><i class='slick-icon-c fa fa-chevron-left'></i></div>",
            nextArrow:
                "<div class='slick-next slick-arrow'><i class='slick-icon-c fa fa-chevron-right'></i></div>",
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                    },
                },
            ],
        });
    }

    jQuery("#close-popup").click(function () {
        setTimeout(function () {
            jQuery(".NewsletterPopup").hide();
        }, 500);
        // console.log("cek display ", jQuery(".NewsletterPopup").css("display"));
    });

    jQuery(window).scroll(function () {
        var position = jQuery(window).scrollTop();
        if (position < 10) {
            jQuery(".bdd-multi-currency").css("color", "#fff");
        } else {
            jQuery(".bdd-multi-currency").css("color", "#000");
        }

        // jQuery(".sort-product-item ")
        //     .sort((a, b) => jQuery(a).data("sort") - jQuery(b).data("sort"))
        //     .appendTo(".sort-product-item");
    });

    // Sort product collection

    number_format = function (number, decimals, dec_point, thousands_sep) {
        number = number.toFixed(decimals);

        var nstr = number.toString();
        nstr += "";
        x = nstr.split(".");
        x1 = x[0];
        x2 = x.length > 1 ? dec_point + x[1] : "";
        var rgx = /(\d+)(\d{3})/;

        while (rgx.test(x1)) x1 = x1.replace(rgx, "$1" + thousands_sep + "$2");

        return x1 + x2;
    };

    if (jQuery(".flat-slider").length > 0) {
        let maxRange = parseInt(
            jQuery(".filter-group-display__price-range-to input").attr("max")
        );

        let currentMin = jQuery(
            ".filter-group-display__price-range-from input"
        ).val();
        let currentMax = jQuery(
            ".filter-group-display__price-range-to input"
        ).val();

        // console.log(maxRange, currentMin, currentMax)

        // console.log(number_format(maxRange, 0, ',', '.') + ' - ' + currentMin + ' - ' +  currentMax)

        jQuery("#flat-slider").slider({
            orientation: "horizontal",
            range: true,
            animate: true,
            min: 0,
            max: Number(maxRange),
            values: [Number(currentMin), Number(currentMax)],
            slide: function (event, ui) {
                if (ui.values[1] - ui.values[0] < 1) {
                    return false;
                }

                // console.log(ui.values[0] + ' - ' + ui.values[1])

                jQuery(".filter-group-display__price-range-from input").val(
                    ui.values[0]
                );
                jQuery(".filter-group-display__price-range-to input").val(
                    ui.values[1]
                );

                var minFormat = number_format(ui.values[0], 0, ",", ".");
                var maxFormat = number_format(ui.values[1], 0, ",", ".");

                jQuery(".flex-price-range .min-price").html("IDR " + minFormat);
                jQuery(".flex-price-range .max-price").html("IDR " + maxFormat);
            },
        });
    }

    if (jQuery("#SortBy").length > 0) {
        document
            .querySelector("#SortBy")
            .addEventListener("change", function () {
                const urlSearchParams = new URLSearchParams(
                    window.location.search
                );

                urlSearchParams.set(this.name, this.value);

                window.location = `?${urlSearchParams}`;
            });
    }
    //Sort and filter collections

    $("#SortBy option[value=created-descending]").text("Newest");

    // if (window.location.href.includes("sort_by")) {
    // } else {
    //     jQuery("#SortBy").prepend(
    //         jQuery("<option  >", {
    //             value: "sortby",
    //             text: "Sort by",
    //         })
    //     );
    // }

    jQuery(
        ".order-summary__section__content .product__description .product__description__variant"
    ).text("cek");
    // console.log("tess", variant_in_cart);

    jQuery("#SortBy option[value=sortby]").attr("selected", "selected");
    if (jQuery(".filter-custom").length > 0) {
        jQuery(".filter-group-display").hide();
        jQuery(".filter-group[open] .filter-group-display").show();
        jQuery(".filter-group-summary").click(function () {
            var parentFilter = jQuery(this).parent();
            if (parentFilter.attr("open")) {
                jQuery(this).parent().find(".filter-group-display").hide(400);
                parentFilter.removeAttr("open");
            } else {
                jQuery(this).parent().find(".filter-group-display").show(400);
                parentFilter.attr("open", "");
            }
        });

        setTimeout(() => {
            var announce_height = jQuery(
                "#shopify-section-announcement"
            ).outerHeight();
            var header_height = jQuery("#shopify-section-header").outerHeight();
            var headerc_height = jQuery(".collectionInfo").outerHeight();

            var hasil_gabungan = announce_height + headerc_height;
            var window_height = jQuery(window).height();

            var hasil_final = window_height - header_height;
            var hasil_mobile_lebih = header_height + headerc_height;
            var hasil_mobile_kurang =
                announce_height + header_height + headerc_height;

            jQuery(window).scroll(function () {
                // console.log(jQuery(this).scrollTop() + ' - ' + (hasil_gabungan+header_height))
                if (jQuery(this).scrollTop() > hasil_gabungan + header_height) {
                    // console.log('lebih hasil gabungan')
                    jQuery(".filter-custom, .sort-custom").addClass(
                        "is-sticky"
                    );
                    jQuery(
                        ".filter-custom.is-sticky, .sort-custom.is-sticky"
                    ).css("max-height", hasil_final + "px");
                    jQuery(
                        ".filter-custom.is-sticky, .sort-custom.is-sticky"
                    ).css("top", header_height + "px");
                } else {
                    jQuery(".filter-custom, .sort-custom").removeClass(
                        "is-sticky"
                    );
                    jQuery(".filter-custom, .sort-custom").css(
                        "max-height",
                        "inherit"
                    );
                }

                // if (jQuery(this).scrollTop() > announce_height) {
                //   jQuery('.filter-custom').css('top', '0px');
                // } else {
                //   jQuery('.filter-custom').css('top', '0px');
                // }
            });
        }, 1000);

        jQuery(".filter-trig-mobile, .close-filter").click(function () {
            jQuery("body").toggleClass("scroll-none");
            jQuery(".kolom-filter").toggleClass("active");
            jQuery(".PageOverlay").toggleClass("is-visible");
        });
    }

    if (jQuery(".template-product").length > 0) {
        jQuery(".Product__SlideshowNavImage").mouseenter(function () {
            jQuery(
                ".Product__SlideshowNavImage[data-media-id=" +
                    jQuery(this).attr("data-media-id") +
                    "] img"
            ).trigger("click");
            // console.log(jQuery(this).attr("data-media-id"));
        });
    }
    jQuery(function () {
        var acc = jQuery(".Footer__Title");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }
    });

    if (jQuery("[name=color_selected]").length > 0) {
        var color_selected = jQuery("[name=color_selected]")
            .val()
            .replace(" ", "-");

        // console.log(jQuery('[name=media_count]').val(), jQuery('[name=media_alt_count]').val())
        if(jQuery('[data-value-color]').length > 1){
            if (
                jQuery("[name=media_count]").val() ==
                jQuery("[name=media_alt_count]").val()
            ) {
                // jQuery('.thumbnail-product, .thumbnail-target').addClass('hide-element');
                // jQuery('.thumbnail-product[data-thumbnail='+color_selected+'], .thumbnail-target[data-target='+color_selected+']').removeClass('hide-element');
    
                jQuery("[name=color_trigg]").each(function (index) {
                    // console.log(jQuery(this).val());
                    jQuery("[data-value-color=" + jQuery(this).val() + "]").trigger(
                        "click"
                    );
                });
    
                setTimeout(() => {
                    // console.log(color_selected, 'timeout');
                    jQuery("[data-value-color=" + color_selected + "]").trigger(
                        "click"
                    );
                }, 500);
    
                // console.log(color_selected)
            }
        }
    }

    jQuery(".ColorSwatch__Radio").click(function () {
        let selected_value = jQuery(this).val();
        // console.log("cek11", selected_value);
        let containtText = selected_value.split("_");
        jQuery("#ProductForm__SelectedValue1").text(containtText[1]);
        // console.log('color clicked')

        // thumbnail dan target (adit)
        selected_value = selected_value.replace(" ", "-");
        if (window.matchMedia("(min-width: 768px)").matches) {
            if (
                jQuery("[name=media_count]").val() ==
                jQuery("[name=media_alt_count]").val()
            ) {
                jQuery(".thumbnail-product, .thumbnail-target").addClass(
                    "hide-element"
                );
                jQuery(
                    ".thumbnail-product[data-thumbnail=" +
                        selected_value +
                        "], .thumbnail-target[data-target=" +
                        selected_value +
                        "]"
                ).removeClass("hide-element");
            }
        } else {
            // $("#div2").not('.myClass');
            if (
                jQuery("[name=media_count]").val() ==
                jQuery("[name=media_alt_count]").val()
            ) {
                // console.log(jQuery(this).val())
                jQuery("[name=color_all]").each(function (index) {
                    if (jQuery(this).val() != selected_value) {
                        // console.log('append', jQuery(this).val());
                        jQuery(
                            jQuery("[data-target=" + jQuery(this).val() + "]")
                        ).appendTo(".tampung-image-variant");
                        // jQuery(jQuery('[data-target='+jQuery(this).val()+']')).hide();
                    } else {
                        jQuery(
                            jQuery(
                                ".tampung-image-variant [data-target=" +
                                    jQuery(this).val() +
                                    "]"
                            )
                        ).appendTo(".Product__Slideshow .flickity-slider");
                        // jQuery(jQuery('[data-target='+jQuery(this).val()+']')).show();
                    }

                    setTimeout(() => {
                        jQuery(".Product__Slideshow").flickity();
                        // jQuery('.Product__Slideshow').flickity( 'remove', jQuery('[data-target='+jQuery(this).val()+']') );
                        jQuery(".Product__Slideshow").flickity("destroy");
                        jQuery(".Product__Slideshow").flickity();
                        jQuery(".Product__Slideshow").addClass("slide-custom");
                        jQuery(
                            ".slide-custom + .Product__SlideshowMobileNav"
                        ).hide();
                    }, 200);

                    setTimeout(() => {
                        var width_dots =
                            jQuery(
                                ".slide-custom .flickity-page-dots"
                            ).width() /
                                2 +
                            55;
                        jQuery(
                            ".slide-custom .flickity-prev-next-button.next"
                        ).css("right", "calc(50% - " + width_dots + "px)");
                        jQuery(
                            ".slide-custom .flickity-prev-next-button.previous"
                        ).css("left", "calc(50% - " + width_dots + "px)");
                    }, 500);
                });
            }
        }
    });

    jQuery("[data-action=open-product-zoom]").click(function () {
        // jQuery(".tampung-image-variant .thumbnail-target").each(function (index) {
        //     jQuery(this).addClass('buka-zoom').appendTo('.Product__Slideshow .flickity-slider');
        // });
    });

    jQuery(".pswp__button--close").click(function () {
        console.log("close-zoom");
        jQuery(".buka-zoom").each(function (index) {
            jQuery(this).appendTo(".tampung-image-variant");
        });
    });

    function click_qview() {
        setTimeout(() => {
            // console.log('call quick view')
            jQuery(".ProductItem .qview-button").on("click", function () {
                setTimeout(() => {
                    jQuery(".qview-select select option").each(function (
                        index
                    ) {
                        if (jQuery(this).val().indexOf("_") >= 0) {
                            var str_color = jQuery(this).val().split("_");
                            jQuery(this).html(str_color[1]);
                            // console.log(str_color[1]);
                        }
                    });
                }, 1500);
            });
        }, 2000);
    }

    click_qview();

    if(jQuery('.template-login').length > 0){
        var handle = setInterval(() => {
            if(jQuery('.ssw-social-login-widget').length > 0){
                jQuery('.ssw-social-login-widget').appendTo('.login-section')
                clearInterval(handle);
            }
        }, 1000);
    }

    var rewardTab = setInterval(() => {
        if(jQuery('.ssw-reward-tab').length > 0){
            jQuery('.ssw-reward-tab').addClass('ssw-reward-tab-left')
            jQuery('.ssw-reward-tab').removeClass('ssw-reward-tab-right')
            clearInterval(rewardTab);
        }
    }, 100);

    var rewardBox = setInterval(() => {
        if(jQuery('.ssw-reward-box').length > 0){
            jQuery('.ssw-reward-box').addClass('ssw-reward-tab-left')
            jQuery('.ssw-reward-box').removeClass('ssw-reward-tab-right')
            clearInterval(rewardBox);
        }
    }, 100);

    // var itemBeforeLaunch = setInterval(() => {
    //     if(jQuery('.remove-item__before-launch').length > 0){
    //         location.href = jQuery('.remove-item__before-launch').attr("href");
    //         jQuery('.remove-item__before-launch').trigger('click')
    //     }
    //     clearInterval(itemBeforeLaunch);
    // }, 100);
  
    var comingSoon = setInterval(() => {
      if($(".remove-ini").length){
        location.href = $(".remove-ini").attr("href")
      }
    }, 0);

    if(jQuery('[name=launchProduct]').length > 0){
        function getNormalisedDatetime(dString) { // yyyy-mm-dd hh:mm:ss
            var parts = dString.split(" ");
            var dParts = parts[0].split("-");
            var tParts = parts[1].split(":");
            return new Date(dParts[0],dParts[1]-1,dParts[2],tParts[0],tParts[1],tParts[2]);
        }

        var start = getNormalisedDatetime(jQuery('[name=launchProduct]').val()).getTime();

        window.addEventListener('load', function() {
            var x = setInterval(function() {
                var today = new Date().getTime();

                timer = start - today;
                if (timer > 0) {
                    jQuery('.ProductForm__AddToCart').addClass('hide-element');
                    // Time calculations for days, hours, minutes and seconds
                    var days = Math.floor(timer / (1000 * 60 * 60 * 24));
                    var hours = Math.floor((timer % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    var minutes = Math.floor((timer % (1000 * 60 * 60)) / (1000 * 60));
                    var seconds = Math.floor((timer % (1000 * 60)) / 1000);
                    // Output the result in an element with id="demo"
                    
                    if(days.toString().length == 1){
                        days = "0" + days;
                    }

                    if(hours.toString().length == 1){
                        hours = "0" + hours;
                    }

                    if(minutes.toString().length == 1){
                        minutes = "0" + minutes;
                    }

                    if(seconds.toString().length == 1){
                        seconds = "0" + seconds;
                    }

                    document.getElementById("days_start").innerHTML = days;
                    document.getElementById("hours_start").innerHTML = hours;
                    document.getElementById("minutes_start").innerHTML = minutes;
                    document.getElementById("seconds_start").innerHTML = seconds;
                }else{
                    clearInterval(x);
                    jQuery('#count_down_start').hide();
                    jQuery('.ProductForm__AddToCart').removeClass('hide-element');
                    // location.reload();
                    return false;
                }
            });
        });
    }
});
